// libraries
import { atom } from 'recoil';

/**
 * LocationPathModeAtom - 길 찾기 모드 상태
 * isCreate: 길 찾기 생성 모드
 * isMove: 길 찾기 이동 모드
 */
export const LocationPathModeAtom = atom({
  key: 'LocationPathModeAtom',
  default: {
    isCreate: true,
    isMove: true
  }
});

/**
 * LocationPositionsAtom - 길 찾기 위치들
 */
export const LocationPositionsAtom = atom({
  key: 'LocationPositionsAtom',
  default: []
});

/**
 * LocationObstaclesAtom - 길 찾기 장애물들
 */
export const LocationObstaclesAtom = atom({
  key: 'LocationObstaclesAtom',
  default: []
});

/**
 * LocationPathsAtom - 길 찾기 경로들
 */
export const LocationPathsAtom = atom({
  key: 'LocationPathAtom',
  default: []
});
